function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { resetPassword } from "@common/actions";
import { parseQuery, validatePassword } from "@common/services/helpers";
import { ERROR_SUBCODE_PASSWORDS_DONT_MATCH, REGEX_PASSWORD, ROUTE_SIGN_IN, STATUS_CODE_SUCCESS } from "@config/constants";
export var ResetPassword = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ResetPassword, PureComponent);
    var _super = _create_super(ResetPassword);
    function ResetPassword(props) {
        _class_call_check(this, ResetPassword);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            email: "",
            serverError: "",
            password: "",
            passwordError: "",
            passwordTouched: false,
            resetsecret: "",
            repeatPassword: "",
            repeatPasswordError: "",
            repeatPasswordTouched: false
        };
        _this.onChange = _this.onChange.bind(_assert_this_initialized(_this));
        _this.resetPassword = _this.resetPassword.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(ResetPassword, [
        {
            /**
     *  Validates a password and sets the appropriate
     *  error in the state.
     * @param {string} key - `password` or `repeatPassword`
     */ key: "validatePassword",
            value: function validatePassword(key) {
                var validityError = REGEX_PASSWORD.test(this.state[key]) ? "" : this.props.i18n.authentication.enterPassword;
                var matchError = this.state.password === this.state.repeatPassword ? "" : this.props.i18n.authentication.passwordsDontMatch;
                this.setState(_define_property({}, "".concat(key, "Error"), validityError || matchError));
            }
        },
        {
            /**
     * Mark all inputs that use validation
     * as touched, which will trigger
     * the validation (see `componentDidUpdate`).
     */ key: "markInputsAsTouched",
            value: function markInputsAsTouched() {
                this.setState({
                    passwordTouched: true,
                    repeatPasswordTouched: true
                });
            }
        },
        {
            /**
     * Renders the navigation links.
     * @returns {*}
     */ key: "renderNavigation",
            value: function renderNavigation() {
                var i18n = this.props.i18n;
                var _i18n_authentication = i18n.authentication, forgottenPassword = _i18n_authentication.forgottenPassword, signIn = _i18n_authentication.signIn;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "secondary-navigation",
                    children: [
                        /*#__PURE__*/ _jsx(NavLink, {
                            to: "/reset-password",
                            activeClassName: "selected",
                            className: "to-forgotten-password",
                            children: forgottenPassword
                        }),
                        /*#__PURE__*/ _jsx(NavLink, {
                            to: "/login",
                            activeClassName: "selected",
                            className: "to-login",
                            children: signIn
                        })
                    ]
                });
            }
        },
        {
            /**
     * Sets the new state for the inputs.
     * @param {Object} event
     */ key: "onChange",
            value: function onChange(param) {
                var target = param.target;
                var newValue = target.value;
                var key = target.name;
                this.setState(_define_property({}, key, newValue));
            }
        },
        {
            /**
     * Render the input.
     * @returns {*}
     */ key: "renderInputs",
            value: function renderInputs() {
                var _this = this;
                var _this_state = this.state, email = _this_state.email, password = _this_state.password, passwordError = _this_state.passwordError, repeatPassword = _this_state.repeatPassword, repeatPasswordError = _this_state.repeatPasswordError;
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(TextField, {
                            disabled: true,
                            className: "ux-text-field-root",
                            autoComplete: "off",
                            InputProps: {
                                className: "ux-input",
                                classes: {
                                    disabled: "ux-input-disabled"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            id: "email",
                            type: "text",
                            name: "email",
                            value: email,
                            label: i18n.authentication.email,
                            margin: "none"
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            className: "ux-text-field-root",
                            InputProps: {
                                onBlur: function() {
                                    return _this.setState({
                                        passwordTouched: true
                                    });
                                },
                                className: "ux-input password",
                                classes: {
                                    error: "ux-input-error"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            FormHelperTextProps: {
                                error: true,
                                classes: {
                                    root: "ux-form-helper-text"
                                }
                            },
                            error: passwordError !== "",
                            helperText: passwordError,
                            id: "password",
                            type: "password",
                            name: "password",
                            value: password,
                            label: i18n.authentication.password,
                            onChange: this.onChange,
                            margin: "none"
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            className: "ux-text-field-root",
                            InputProps: {
                                onBlur: function() {
                                    return _this.setState({
                                        repeatPasswordTouched: true
                                    });
                                },
                                className: "ux-input password",
                                classes: {
                                    error: "ux-input-error"
                                }
                            },
                            InputLabelProps: {
                                classes: {
                                    root: "ux-input-label"
                                }
                            },
                            FormHelperTextProps: {
                                error: true,
                                classes: {
                                    root: "ux-form-helper-text"
                                }
                            },
                            error: repeatPasswordError !== "",
                            helperText: repeatPasswordError,
                            id: "repeat-password",
                            type: "password",
                            name: "repeatPassword",
                            value: repeatPassword,
                            label: i18n.authentication.repeatPassword,
                            onChange: this.onChange,
                            margin: "none"
                        })
                    ]
                });
            }
        },
        {
            key: "resetPassword",
            value: /**
     * Send the new password along with the
     * email and the secret to the backend.
     * On success... // TODO
     * On error, display the server error.
     * @param {Object} event
     */ function resetPassword(event) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_state, email, password, passwordError, repeatPassword, passwordTouched, repeatPasswordError, repeatPasswordTouched, resetsecret, errors, hasInvalidInputDataAfterBlur, hasInvalidInputDataBeforeBlur, trimmedEmail, data, response, error, hasSpecificServerError, errorText;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                event.preventDefault();
                                _this_state = _this.state, email = _this_state.email, password = _this_state.password, passwordError = _this_state.passwordError, repeatPassword = _this_state.repeatPassword, passwordTouched = _this_state.passwordTouched, repeatPasswordError = _this_state.repeatPasswordError, repeatPasswordTouched = _this_state.repeatPasswordTouched, resetsecret = _this_state.resetsecret;
                                errors = _this.props.i18n.errors;
                                hasInvalidInputDataAfterBlur = passwordError || repeatPasswordError;
                                hasInvalidInputDataBeforeBlur = !passwordTouched && !validatePassword(password, null) || !repeatPasswordTouched && !validatePassword(repeatPassword, null);
                                if (hasInvalidInputDataAfterBlur || hasInvalidInputDataBeforeBlur) {
                                    return [
                                        2,
                                        _this.markInputsAsTouched()
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                trimmedEmail = email.replace(/\s/g, "");
                                data = {
                                    email: trimmedEmail,
                                    password: password,
                                    repeatPassword: repeatPassword,
                                    secret: decodeURIComponent(resetsecret)
                                };
                                return [
                                    4,
                                    _this.props.resetPassword(data)
                                ];
                            case 2:
                                response = _state.sent();
                                if (response.status === STATUS_CODE_SUCCESS) {
                                    _this.props.history.push(ROUTE_SIGN_IN);
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                hasSpecificServerError = error && error.subcode;
                                if (hasSpecificServerError) {
                                    errorText = errors["error".concat(error.subcode)];
                                    switch(error.subcode){
                                        case ERROR_SUBCODE_PASSWORDS_DONT_MATCH:
                                            _this.setState({
                                                passwordError: errorText,
                                                repeatPasswordError: errorText,
                                                serverError: ""
                                            });
                                            break;
                                        default:
                                            _this.setState({
                                                serverError: errorText
                                            });
                                            break;
                                    }
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_state = this.state, requestSuccess = _this_state.requestSuccess, serverError = _this_state.serverError;
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "reset-password-component".concat(requestSuccess ? " success" : ""),
                    children: [
                        this.renderNavigation(),
                        /*#__PURE__*/ _jsx("div", {
                            className: "authentication-link-description margin-top-tiny margin-bottom-small",
                            children: i18n.authentication.chooseNewPassword
                        }),
                        /*#__PURE__*/ _jsxs("form", {
                            onSubmit: this.resetPassword,
                            children: [
                                this.renderInputs(),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "error-server",
                                    children: serverError
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    className: "button raised full-width margin-top-tiny",
                                    type: "submit",
                                    children: i18n.common.saveChange
                                })
                            ]
                        })
                    ]
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _parseQuery = parseQuery(this.props.location.search), email = _parseQuery.email, resetsecret = _parseQuery.resetsecret;
                this.setState({
                    email: email,
                    resetsecret: resetsecret
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                if (this.state.passwordTouched) {
                    this.validatePassword("password");
                }
                if (this.state.repeatPasswordTouched) {
                    this.validatePassword("repeatPassword");
                }
            }
        }
    ]);
    return ResetPassword;
}(PureComponent);
export default connect(null, {
    resetPassword: resetPassword
})(withRouter(ResetPassword));
